import React, { useRef, useState } from 'react';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  TextField,
  Typography
} from '@mui/material';
import { styled } from '@mui/system';
import { string, bool, func } from 'prop-types';

const StyledDialogTitle = styled(DialogTitle)(() => ({
  backgroundColor: '#ff4635',
  whiteSpace: 'pre-wrap'
}));

const DeleteTitle = styled(Typography)(() => ({
  fontSize: '1.25rem',
  fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  fontWeight: 500,
  lineHeight: 1.6,
  letterSpacing: '0.0075em',
  whiteSpace: 'pre-wrap',
  display: 'block',
  wordBreak: 'break-all'
}));

const StyledDialogContentText = styled(DialogContentText)(() => ({
  marginTop: '8px'
}));

const DeleteAddressbookDialog = props => {
  const {
    dialogTitle,
    entityTitle,
    dialogContentText,
    textFieldLabel,
    open,
    onClose: onModalClose,
    onDelete
  } = props;
  const inputElement = useRef(null);
  const [inputFieldError, setInputFieldError] = useState(false);

  const handleOk = () => {
    if (inputElement?.current?.value === entityTitle) {
      onDelete();
    } else {
      setInputFieldError(true);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={() => {
        setInputFieldError(false);
        onModalClose();
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <StyledDialogTitle id="alert-dialog-title">
        <DeleteTitle>
          {dialogTitle}
        </DeleteTitle>
      </StyledDialogTitle>
      <DialogContent>
        <StyledDialogContentText id="alert-dialog-description">
          {dialogContentText}
        </StyledDialogContentText>
        <TextField
          label={textFieldLabel}
          fullWidth
          margin="normal"
          variant="outlined"
          inputRef={inputElement}
          error={inputFieldError}
          helperText={inputFieldError ? 'Invalid name' : ''}
        />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            setInputFieldError(false);
            onModalClose();
          }}
          variant="outlined"
          color="primary"
        >
          Cancel
        </Button>
        <Button onClick={handleOk} variant="outlined" color="primary" autoFocus>
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

DeleteAddressbookDialog.propTypes = {
  dialogTitle: string.isRequired,
  entityTitle: string.isRequired,
  dialogContentText: string.isRequired,
  open: bool.isRequired,
  onClose: func.isRequired,
  onDelete: func.isRequired
};

export default DeleteAddressbookDialog;
